import { Box, Typography } from "@dealer-center/core-components";

export const LeadLifecyclesPage = () => (
  <Box sx={{ p: 3 }}>
    <Typography variant="h6">Lead Lifecycles</Typography>
    <Typography sx={{ color: "text.secondary", mt: 1 }} variant="body-md">
      TODO: implement Lead Lifecycles
    </Typography>
  </Box>
);
